import React from 'react'
import BigBox from '../../components/ad_types/BigBox'
import zonePosts from './../../components/zone_posts/zonePosts'
import SidebarHeadlines from './../../components/headlines/sidebar/SidebarHeadlines'

import './AncillaryLeague.scss'

export default function Sidebar({ league = '' }) {
    const Headlines = zonePosts(league, 'headlines')(SidebarHeadlines)
    const uppercaseLeagueStr = league.toUpperCase()

    return (
        <React.Fragment>
            <BigBox bg={false} view="all" visible={true} refresh={false} />
            <Headlines postHeader={uppercaseLeagueStr} />
        </React.Fragment>
    )
}
